import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit {
  @Input() model: boolean;
  @Output() modelChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() disabled: boolean;
  @Input() label: string;

  constructor() { }

  ngOnInit(): void {
  }

}
